const LINK_PATH = "/ring-appstore/link";
const HOME_PATH = "/ring-appstore/home";

function validRingLinkSearch(search: string): string | null {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  if (params.size !== 2 || params.getAll("time").length !== 1 || params.getAll("nonce").length !== 1) {
    return null;
  }
  const time = params.get("time") ?? "";
  const nonce = params.get("nonce") ?? "";
  if (!/^\d{13}$/.test(time) || !/^[A-Za-z0-9_-]{43}$/.test(nonce)) return null;
  return `?time=${encodeURIComponent(time)}&nonce=${encodeURIComponent(nonce)}`;
}

/** Only allow the two fixed Ring destinations through the sign-in return URL. */
export function validatedRingAppstoreDestination(raw: string): string | null {
  if (raw === HOME_PATH) return HOME_PATH;
  if (!raw.startsWith(`${LINK_PATH}?`) || raw.startsWith("//") || raw.includes("#")) return null;
  const search = validRingLinkSearch(raw.slice(LINK_PATH.length + 1));
  return search ? `${LINK_PATH}${search}` : null;
}

/** Preserve Ring's signed, short-lived redirect only for its fixed account-link route. */
export function ringAppstoreAuthReturn(path: string, search: string): string | null {
  if (path === HOME_PATH && !search) return HOME_PATH;
  if (path !== LINK_PATH) return null;
  const sanitized = validRingLinkSearch(search);
  return sanitized ? `${LINK_PATH}${sanitized}` : null;
}
